export default "__VITE_ASSET__Bqwcra03__"